import React from 'react'
import styles from './Aboutus.module.css';
import { Clapperboard } from 'lucide-react';
import data from './AboutUsData';
import secondData from './NextAboutUs';
import ContactForm from './AboutUsContactForm';
import Footer from '../../common/UI/Footer'

function Aboutus() {
  return (
    <>
    <div>
      <div className={styles.outerOne}>
        <div className={styles.innerOne}>
            <h1 className={styles.innerHeading}>Welcome to Suno Kahaniyan</h1>
            <p className={styles.innerPara}>Your go-to destination for captivating audio stories and reading experiences.</p>
            <div>
                <button className={styles.startListning}>
                    Start Listening
                </button>
                <button className={styles.exploreStories}>
                    Explore Stories
                </button>
            </div>
        </div>
      </div>
      {/* section second */}
      <div>
        <div className={styles.secondSection}>
            <div className={styles.secondSectionBox}>
                    <h1 className={styles.experience}>
                        Experience Stories Like Never Before
                    </h1>
                    <p className={styles.immersePara}>
                        Welcome to Suno Kahaniyan, where storytelling meets innovation. Immerse yourself in a world of captivating audio stories and reading experiences across diverse genres.
                    </p>
                <div>
                    <button className={styles.startListning}>
                         Start Listening
                    </button>
                    <button className={styles.exploreStories}>
                        Explore Library
                    </button>
                </div>
            </div>
            <div className={styles.redDiv}>
                <div>
                    <div className={styles.redCirclediv}>
                        <Clapperboard className={styles.insideIcon} />
                    </div>
                    <p className={styles.audioStories}>Audio Stories</p>
                    <p className={styles.immersePara}> Immersive listening experience</p>
                </div>
            </div>
        </div>
          <div className={styles.ourMission}>
            <h2 className={styles.ourMissionhead}>Our Mission</h2>
            <p className={styles.immersePara}> At Suno Kahaniyan, we ignite imagination and transport you to different worlds through the magic of storytelling. We believe stories have the power to inspire, entertain, and enlighten,we ignite imagination and transport you to different worlds through the magic of storytelling. We believe stories have the power to inspire, entertain, and enlighten.</p>
          </div>
        </div>
        {/* section third */}
        <div style={{marginTop:'5rem'}}>
            <div className={styles.outDiv}>
                <h2 className={styles.experience}>About Suno Kahaniyan</h2>
                <div className={styles.borderBottom}></div>
            </div>
            <div className={styles.gridBoxes}>
                {secondData.map(story => (
                    <div key={story.id} className={styles.gridDiv}>
                    <div className={styles.redCircledivlit}>
                        <Clapperboard className={styles.insideIconlit} />
                    </div>
                    <h3 className={styles.audioStories}>{story.title}</h3>
                    <p className={styles.immersePara}>{story.description}</p>
                    </div>
                ))}
            </div>
        </div>
        {/* section four */}
        <div className={styles.ourMissionouter}>
            <div className={styles.ourMissionlit}>
                <h2 className={styles.ourMissionhead}>Our Mission</h2>
                <p className={styles.immersePara}> At Suno Kahaniyan, we ignite imagination and transport you to different worlds through the magic of storytelling. We believe stories have the power to inspire, entertain, and enlighten,we ignite imagination and transport you to different worlds through the magic of storytelling. We believe stories have the power to inspire, entertain, and enlighten.</p>
                <button style={{ marginBottom:'4rem' }} className={styles.startListning}>
                         Start Listening
                </button>
            </div>
        </div>
        {/* section five */}
        <div style={{ marginTop:'5rem' }}>
            <div className={styles.outDiv}>
                <h2 className={styles.experience}>Why Choose Suno Kahaniyan</h2>
                <div className={styles.borderBottom}></div>
            </div>
            <div className={styles.gridBoxes}>
                {data.map((item) => (
                    <div key={item.id} className={styles.gridDiv}>
                        <div className={styles.redCircledivlit}>
                            <item.icon className={styles.insideIconlit} />
                        </div>
                        <h3 className={styles.audioStories}>{item.title}</h3>
                        <p className={styles.immersePara}>{item.description}</p>
                    </div>
                ))}
            </div>
           
            <div style={{ textAlign:'center' }}>
                <button className={styles.startListning}>
                    Explore All Features
                </button>
            </div>
        </div>  
        {/* section six */} 
        <div className={styles.inputDiv} >
            <div className={styles.outDiv}>
                <h2 className={styles.experience}>Get in Touch</h2>
                <div className={styles.borderBottom}></div>
                <p className={styles.immersePara}> Have questions or suggestions? We'd love to hear from you. Contact us using the form below.</p>
            </div>
            <ContactForm/>
        </div>
    </div>
    <Footer/>
    </>
  )
}

export default Aboutus
